import { Card, CardContent } from "@/components/ui/card";
import { formatNumber } from "@/modules/collector_v2/lib/formatters";

export function KpiCard({ title, value, description, icon: Icon, testid }) {
  return (
    <Card data-testid={testid} className="kpi-card">
      <CardContent className="kpi-content">
        <div>
          <p>{title}</p>
          <strong>{formatNumber(value)}</strong>
          <span>{description}</span>
        </div>
        <div className="kpi-icon"><Icon className="h-5 w-5" /></div>
      </CardContent>
    </Card>
  );
}
